import React, { useEffect, useState } from "react";
import './Articles.css';
import axios from "axios";
import { FaHeart, FaRegHeart, FaTrash } from "react-icons/fa";
import { toast } from "react-toastify";
import ConfirmationPopup from "../../components/ConfirmationPopup/ConfirmationPopup";
import { FiEye } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

const backendUrl = process.env.REACT_APP_BACKEND_URL;
const categories = [
	"All", "Welfare", "Environment", "Empowerment", "Youth", "Education",
	"Culture", "Harmony", "Spirituality", "Infrastructure", "Events"
];

const adminToken = localStorage.getItem("adminToken");

const Articles = () => {
	const [articleData, setArticleData] = useState([]);
	const [loading, setLoading] = useState(true);
	const [selectedCategory, setSelectedCategory] = useState("All");
	const [confirmPopup, setConfirmPopup] = useState(false);
	const [blogToRemove, setBlogToRemove] = useState(null);
	const navigate = useNavigate();

	const handleLike = async (id) => {

		const adminToken = localStorage.getItem("adminToken");
		const token = localStorage.getItem('token');
		try {
			await axios.post(`${backendUrl}/blog/${id}/like`, {}, {
				headers: {
					Authorization: `Bearer ${token}`,
				},
			});
			fetchArticles();
		} catch (error) {
			if (adminToken) {
				toast.warning("Admins can't like a blog.", {
					position: "top-center",
					theme: "dark",
				});
			} else {
				toast.warning('You need to log in to like a blog.', {
					position: "top-center",
					theme: "dark",
				});
			}
		}
	};

	const formatDate = (isoDate) => {
		const date = new Date(isoDate);

		const options = { month: 'short', day: 'numeric', year: 'numeric' };
		const formattedDate = new Intl.DateTimeFormat('en-US', options).format(date);

		// Add ordinal suffix to the day
		const day = date.getDate();
		const dayWithSuffix =
			day +
			(day % 10 === 1 && day !== 11
				? 'st'
				: day % 10 === 2 && day !== 12
					? 'nd'
					: day % 10 === 3 && day !== 13
						? 'rd'
						: 'th');

		return formattedDate.replace(day.toString(), dayWithSuffix);
	};

	const handleDeleteArticle = (id) => {
		setBlogToRemove(id);
		setConfirmPopup(true);
	}

	const removeArticle = async () => {
		const adminToken = localStorage.getItem("adminToken");
		try {
			const response = await axios.delete(`${backendUrl}/blog/${blogToRemove}`, {
				headers: {
					Authorization: `Bearer ${adminToken}`,
				},
			});
			if (response.status === 200) {
				toast.success(response.data.message || "Blog deleted successfully!", {
					position: "top-center",
					theme: "dark",
				});
				setBlogToRemove(null)
				fetchArticles();
			} else {
				toast.error("Something went wrong..!", {
					position: "top-center",
					theme: "dark",
				});
			}
		} catch (error) {
			toast.error(error.response?.data?.message || "Failed to delete..!", {
				position: "top-center",
				theme: "dark",
			});
		}
	}

	const fetchArticles = async () => {
		try {
			const token = localStorage.getItem('token');
			const response = await axios.get(`${backendUrl}/blog`, {
				headers: token ? { Authorization: `Bearer ${token}` } : {},
			});
			setArticleData(response.data);

		} catch (error) {
			console.error(error);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchArticles();
	}, []);

	// Filter articles based on selected category
	const filteredArticles = selectedCategory === "All"
		? articleData
		: articleData.filter((article) =>
			article.category.includes(selectedCategory)
		);

	return (
		<div className="articlesContainer">
			{/* Scrollable Category Bar */}
			<div className="categoryBar">
				{categories.map((category) => (
					<button
						key={category}
						className={`categoryButton ${selectedCategory === category ? "active" : ""}`}
						onClick={() => setSelectedCategory(category)}
					>
						{category}
					</button>
				))}
			</div>

			{/* Display filtered articles in a flex container */}
			<div className="articlesFlexContainer">
				{loading && <div className="spinner"></div>}
				{filteredArticles.map((article, index) => (
					<div key={index} className="articleCard">
						{adminToken &&
							<button
								onClick={() => handleDeleteArticle(article._id)}
								className="removeArticleBtn"
							>
								<FaTrash />
							</button>
						}
						<img
							src={article.image}
							alt="Article"
							className="cardImage"
						/>
						<div className="cardDetails">
							<h3 className="cardTitle" onClick={() => navigate(`/article/${article._id}`)}>
								{article.data.find(item => item.type === "title")?.value}
							</h3>
							<div className="cardMeta">
								<span className="cardDate">{formatDate(article.createdAt)}</span>
								<div className="cardCountCont">
									<span className="cardIconCont" onClick={() => handleLike(article._id)}>
										{article.isLiked ? <FaHeart className="liked" /> : <FaRegHeart className="notLiked" />}
										<span className="likedCount">{article.likesCount}</span>
									</span>
									<span className="cardIconCont">
										<FiEye />
										<span className="likedCount">{article.views}</span>
									</span>
								</div>
							</div>
							<p className="cardDescription">
								{article.data.find(item => item.type === "paragraph")?.value}
							</p>
						</div>
					</div>
				))}
			</div>

			<ConfirmationPopup
				isOpen={confirmPopup}
				onClose={() => setConfirmPopup(false)}
				onConfirm={() => {
					removeArticle();
					return false
				}}
			/>
		</div>
	);
};

export default Articles;
